import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DateUtils } from 'src/app/_helpers/date-utils';
import { GetOfertasActivasDocenteResponse } from '../responses/get-ofertas-activas-docente-response';

@Component({
  selector: 'app-doc-oferta-postulantes',
  templateUrl: './doc-oferta-postulantes.component.html',
  styleUrls: ['./doc-oferta-postulantes.component.css']
})
export class DocOfertaPostulantesComponent implements OnInit{
  public breadcrumb : any;

  dataOferta : GetOfertasActivasDocenteResponse;

  constructor(private _route: ActivatedRoute,
              private router : Router,
              private toastr : ToastrService){
  }

  ngOnInit()
  {
    this._route.queryParams.subscribe((params) => {
      if (params.detallesOferta) {
        this.dataOferta = JSON.parse(params.detallesOferta);
      }
    });
    if(!this.dataOferta || (this.dataOferta.numeroPostulantes <= 0 && this.dataOferta.listaPostulantes.length>1))
    {
      this.toastr.error('No se ha podido recuperar información relacionada a los postulantes de la oferta de trabajo porque la lista puede estar vacía.','Error');
      this.router.navigate(['empresa/ofertasPublicadas'], 
      {
        queryParams: {},
        skipLocationChange: true
      });
    }
    this.breadcrumb = {
      'mainlabel': 'Postulantes'
      };
  }

  convertDate(date:string) : string
  {
    const dateObj = new Date(date);
    return DateUtils.formatDate(dateObj);
  }

  mostrarDetalle(postulante)
  { 
    if(postulante && postulante.idUsuario>0)
    {
      this.router.navigate(['docente/oferta/postulado'], {
        queryParams: { postulante: JSON.stringify(postulante) },
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    else
      this.toastr.error('No se ha podido acceder a la información del postulado. Inténtalo de nuevo.','Error');
  }

}
